import { DatasetExtraField } from '@warebee/shared/common';
import {
  ActivityEventProcessType,
  ActivityEventType,
} from '@warebee/shared/import-converter';

export const DATASET_QUERY_VALUE_CONCATENATION = '-_-';

export type DatasetQueryBuilderParams = {
  datasetId: string;
  extraFields?: DatasetExtraField[];
};

export type DocumentContextQueryBuilderParams = {
  documentId: string;
  from?: string;
  to?: string;
  shiftDetectionOffset?: number;
};

export type ActivityFeedQueryBuilderParams = DatasetQueryBuilderParams & {
  agentId?: string;
  disabledProcessTypes?: ActivityEventProcessType[];
  disabledAgentTypes?: string[];
  informationalEventTypes?: ActivityEventType[];
  applyTimeFilterToJobs?: boolean;
};

export type DocumentBaseBaseQueryBuilderParams = {
  documentContext: DocumentContextQueryBuilderParams;
};

export type ActualityBaseQueryBuilderParams =
  DocumentBaseBaseQueryBuilderParams & {
    activity: ActivityFeedQueryBuilderParams;
  };

export type ActualityQueryBuilderParams = ActualityBaseQueryBuilderParams & {
  layout: DatasetQueryBuilderParams;
  itemSet: DatasetQueryBuilderParams;
  assignment: DatasetQueryBuilderParams;
  activityPlan: DatasetQueryBuilderParams;
  inventory: DatasetQueryBuilderParams;
};
